import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import {
	formatWorkerAssignmentFranchiseExcelList,
	formatWorkerAssignmentFranchiseList,
} from './worker-assignment-franchise.helper';
import { WorkerAssignmentFranchiseActions } from './worker-assignment-franchise.redux';
import {
	IPayloadDeleteWorkerAssignmentFranchiseRequest,
	IPayloadGetWorkerAssignmentFranchiseExcelListRequest,
	IPayloadGetWorkerAssignmentFranchiseListRequest,
} from './worker-assignment-franchise.type';

export function* getWorkerAssignmentFranchiseListSaga(
	action: PayloadAction<IPayloadGetWorkerAssignmentFranchiseListRequest>
) {
	const { callback, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetWorkerAssignmentFranchiseListResponse> =
			yield API.getWorkerAssignmentFranchiseList({ ...rest });

		const content = formatWorkerAssignmentFranchiseList(res?.data?.content);

		yield put(
			WorkerAssignmentFranchiseActions.getWorkerAssignmentFranchiseListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			WorkerAssignmentFranchiseActions.getWorkerAssignmentFranchiseListFailure()
		);
	}
}

export function* getWorkerAssignmentFranchiseExcelListSaga(
	action: PayloadAction<IPayloadGetWorkerAssignmentFranchiseExcelListRequest>
) {
	const { callback, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetWorkerAssignmentFranchiseListResponse> =
			yield API.getWorkerAssignmentFranchiseList({ ...rest });

		const content = formatWorkerAssignmentFranchiseExcelList(
			res?.data?.content
		);

		yield put(
			WorkerAssignmentFranchiseActions.getWorkerAssignmentFranchiseExcelListSuccess()
		);
		callback?.({ data: content });
	} catch (error) {
		callback?.({ error });
		yield put(
			WorkerAssignmentFranchiseActions.getWorkerAssignmentFranchiseExcelListFailure()
		);
	}
}

export function* deleteWorkerAssignmentFranchiseSaga(
	action: PayloadAction<IPayloadDeleteWorkerAssignmentFranchiseRequest>
) {
	const { callback, ids } = action.payload;

	try {
		yield API.deleteWorkerAssignmentFranchise(ids);

		yield put(
			WorkerAssignmentFranchiseActions.deleteWorkerAssignmentFranchiseSuccess()
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			WorkerAssignmentFranchiseActions.deleteWorkerAssignmentFranchiseFailure()
		);
	}
}
